<div class="feed-filters">

  @if(paginatedDeliveries()){
    <frontend-pagination-type-three
      [classes]="'pg-purple justify-content-between mb-0'" [loading]="loading()"
      [meta]="paginatedDeliveries().meta" [lastPage]="paginatedDeliveries().meta.last_page"
      [links]="paginatedDeliveries().links" [simplified]="true" (changePage)="doGetPaginatedDeliveries($event)">
    </frontend-pagination-type-three>

  }

  <!-- TODO - this button is not visible. Why? -->
  <button
    type="button"
    class="btn btn-primary w-100 toggle-filters"
    (click)="areFiltersCollapsed = !areFiltersCollapsed"
    [attr.aria-expanded]="!areFiltersCollapsed"
    aria-controls="contributionsFilters"
    *transloco="let t; scope: 'contributions'"
    >
    {{t('filters.quick_filters')}} <i class="ml-2 fa-solid fa-angle-down"></i>
  </button>


  <div
    class="filters-body"
    id="contributionsFilters"
    [collapse]="areFiltersCollapsed"
    [isAnimated]="true"
    >
    <form [formGroup]="filtersForm" *transloco="let t">
      <div class="form-group">
        <label class="filters-title">{{t('common.filter')}}</label>
        <div class="d-flex flex-wrap gap-2">
          @for (state of filterStates; track state) {
            <span
              class="badge badge-pill clickable"
            [ngClass]="{
              'badge-primary': isStateActive(state),
              'badge-secondary': !isStateActive(state)
            }"
              (click)="selectFilterState(state)"
              >
              {{t(state.translationKey)}}
            </span>
          }
          <span
            class="badge badge-pill badge-light clickable"
            (click)="clearAllFilters()"
            *transloco="let t"
            >
            <span class="fa-close fa-solid mr-1"></span>
            {{t('common.remove_filters')}}
          </span>
          <span
            class="badge badge-pill badge-light clickable"
            (click)="setFiltersToDefault()"
            *transloco="let t"
            >
            <span class="fa-close fa-solid mr-1"></span>
            {{t('common.reset')}}
          </span>
        </div>
      </div>

      <!-- Sort Options -->
      <div class="form-group mt-3" *transloco="let t">
        <span class="filters-title">{{t('common.sort')}}</span>
        <div class="d-flex align-items-center gap-1 flex-wrap">
          @for (sortable of sortCriteria; track sortable) {
            <span
              (click)="setSortOrderParams(sortable)"
              class="badge badge-pill clickable"
            [ngClass]="{
              'badge-primary': options().sort_by === sortable.sort_by,
              'badge-secondary': options().sort_by !== sortable.sort_by
            }"
              >
              @if (options().sort_by === sortable.sort_by) {
                <span>
                  @if (sortable.sort_order === 'asc') {
                    <span><i class="fa-solid fa-arrow-up mr-1"></i></span>
                  }
                  @if (sortable.sort_order === 'desc') {
                    <span><i class="fa-solid fa-arrow-down mr-1"></i></span>
                  }
                </span>
              }
              @if(options().sort_by === sortable.sort_by && sortable.sort_order === 'asc'){
                <span *transloco="let t; scope: sortable.translationScopeAsc">{{t(sortable.translationKeyAsc)}}</span>
              } @else {
                <span *transloco="let t; scope: sortable.translationScopeDesc">{{t(sortable.translationKeyDesc)}}</span>
              }
            </span>
          }
          <span
            class="badge badge-pill badge-light clickable"
            (click)="clearSorting()"
            >
            <span class="fa-close fa-solid mr-1"></span>
            {{t('common.reset')}}
          </span>
        </div>
      </div>

      <!-- Items Per Page -->
      <div class="form-group mt-3">
        <label for="itemsPerPage" class="filters-title">{{t('navigation.items_per_page')}}</label>
        <select
          class="form-select"
          id="itemsPerPage"
          formControlName="items_per_page"
          >
          <option [ngValue]="5">5</option>
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
          <option [ngValue]="100">100</option>
        </select>
      </div>
    </form>
  </div>

  <!-- <h5>Debugging</h5>
  <p>
    <b>cultures()</b>: {{cultures() | json}}<br>
    <b>filters()</b>: {{filters() | json}}<br>
    <b>options()</b>: {{options() | json}}<br>
  </p> -->

  @if(cultures().length > 0){
    <div class="mt-3">
      <label for="cultures" *transloco="let t" class="filters-title">{{ t('common.national_cultures')}}</label>
      <culture-selector-type-one [cultures]="cultures()" [loading]="loading()"
        (selected)="selectCulture($event)" (deselected)="deselectCulture($event)"
        [selectedCultures]="selectedCultures()" [placeholderTranslationKey]="">
      </culture-selector-type-one>
    </div>
  }

</div>